import styled from 'styled-components';
import icon_success from '../../../assets/image/icon_success.png';
import icon_warn from '../../../assets/image/icon_warn.png';

const Container = styled.div`
.pm-toast {
  position: fixed;
  width: 100%;
  top: 40%;
  left: 0;
  z-index: 777;
  font-size: .28rem;
  text-align: center;
  display: flex;
  justify-content: center;
}
.pm-toast__notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: .36rem .50rem;
  border-radius: .16rem;
  color: #fff;
  min-width: 2.08rem;
  max-width: 4.40rem;
  background: rgba(0, 0, 0, .7);
}
.pm-toast__icon {
  margin-top: .006rem;
  margin-bottom: .008rem;
  width: .46rem;
  height: .46rem;
  background-size: .46rem .46rem;
  background-repeat: no-repeat;
  background-position: center;
}

.pm-toast__icon--success {
  background-image: url(${icon_success});
}

.pm-toast__icon--warn {
  background-image: url(${icon_warn});
}

.pm-toast__icon--none {
  display: none;
}

.pm-toast__message {
  font-size: .28rem;
  line-height: .38rem;
}

.pm-toast__content {
  margin-top: .16rem;
  font-size: .22rem;
  line-height: .30rem;
}
`;

export {
  Container,
}
